module.exports = __webpack_public_path__ + "static/img/1.0611fdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/1.png
// module id = 1Xip
// module chunks = 0